// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var UsersController = function ($scope, User, EmailAddressesDownload) {
    $scope.wasSearching = false;
    $scope.filter = "";
    $scope.search = "";

    $scope.updateFilter = function () {
        $scope.users = $scope.paginator(function (options, callback) {
            return User.query(options, function () { callback(); $scope.wasSearching = options.search; });
        }, { search: $scope.search }, 20);
    };

    $scope.downloadEmails = function () {
        $scope.isL = true;
        var downloadInfo = new EmailAddressesDownload();
        downloadInfo.$save({
            
        }, function () {
            window.location = downloadInfo.Url;
            $scope.isL = false;
        }, function () { $scope.isL = false; });
    }

    $scope.updateFilter();
};
UsersController.$inject = ['$scope', 'User', 'EmailAddressesDownload'];
